import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<g clip-path="url(#a)" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" > <path d="M10.167 3.167v5.666M1.833 3.167v5.666M6 1.167v9.666" /> </g> <defs> <clipPath id="a"> <path fill="currentColor" d="M0 0h12v12H0z" /> </clipPath> </defs>' }
  })
);